import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthFacadeService } from '@ib-core/services/auth-facade.service';
import { AuthHttpService } from '@ib-core/services/auth-http.service';
import { MatSnackBarService } from '@ib-core/services/snackbar.service';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'ib-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss'],
})
export class EmailConfirmationComponent {
  public loading = false;

  constructor(
    private authHttpS: AuthHttpService,
    public authFacadeS: AuthFacadeService,
    private snackbarS: MatSnackBarService,
    private translateS: TranslocoPipe,
    private router: Router 
  ) {}

  // resend(): void {
  //   this.loading = true;
  //   this.authHttpS
  //     .sendRegistrationLink(this.authFacadeS.authUser.email)
  //     .subscribe({
  //       next: () => {
  //         this.loading = false;
  //         this.snackbarS.show({
  //           msg: this.translateS.transform('page.email-confirm.send-success'),
  //           type: 'success',
  //         });
  //       },
  //       error: () => {
  //         this.loading = false;
  //       },
  //     });
  // }

  login(): void {
    this.authFacadeS.loginRedirect();
  }
  // redirectToLogin(): void {
  //   this.authFacadeS.loginRedirect();
  // }
}
//   redirectToLogin(): void {
//     this.authFacadeS.login
//   this.router.navigate(['/login']); // Ensure '/login' matches your routing configuration
// }


